import { Injectable } from '@angular/core';
import { VoiceService } from 'app/core';
import { Observable } from 'rxjs';
import { CallStatus, Ticket } from '../../models';
import { VoiceProxyService } from './voice-proxy.service';

/**
 * Abstract class that serves as a base for multiple voice providers (e.g. Twilio)
 *
 * @export
 */
@Injectable()
export class MultiProviderVoiceService implements VoiceService {
    constructor(private proxy: VoiceProxyService) {}

    init(): void {
        this.proxy.init();
    }

    destroy(): void {
        this.proxy.destroy();
    }

    deviceStatus(): Observable<CallStatus> {
        return this.proxy.deviceStatus();
    }

    connectionError(): Observable<{ ticket: Ticket }> {
        return this.proxy.connectionError();
    }

    registerTicket(ticketId: string, conferenceId: string): void {
        this.proxy.registerTicket(ticketId, conferenceId);
    }

    clearTicket(ticketId: string): void {
        this.proxy.clearTicket(ticketId);
    }

    hasCall(ticketId: string): boolean {
        return this.proxy.hasCall(ticketId);
    }

    hasCalls(): boolean {
        return this.proxy.hasCalls();
    }

    pickUpCall(ticket: Ticket): void {
        this.proxy.pickUpCall(ticket);
    }

    hasConnection(ticketId: string): boolean {
        return this.proxy.hasConnection(ticketId);
    }

    isMuted(ticketId: string): boolean {
        return this.proxy.isMuted(ticketId);
    }

    isOnHold(ticketId: string): boolean {
        return this.proxy.isOnHold(ticketId);
    }

    disconnect(ticketId: string, disconnectCallback?: () => void): void {
        this.proxy.disconnect(ticketId, disconnectCallback);
    }

    mute(ticketId: string): void {
        this.proxy.mute(ticketId);
    }

    pause(ticketId: string): void {
        this.proxy.pause(ticketId);
    }

    async transfer(ticketId: string, forwardTo: string): Promise<void> {
        this.proxy.transfer(ticketId, forwardTo);
    }

    async createCall(originNumber: string, destinationNumber: string, ticketId: string): Promise<any> {
        this.proxy.createCall(originNumber, destinationNumber, ticketId);
    }
}
